// Build dynamic rows from parsedSection2 only (no static rows)
const toCamel = (s = "") =>
  String(s)
    .trim()
    .replace(/[^a-zA-Z0-9]+([a-zA-Z0-9])/g, (_, c) => c.toUpperCase())
    .replace(/^([A-Z])/, (m) => m.toLowerCase());

const parseNumberLike = (v) => {
  if (v == null) return v;
  if (typeof v === "number") return v;
  const s = String(v).trim().replace(/,/g, "");
  const n = Number(s);
  return Number.isFinite(n) ? n : s;
};

export default function useManualFields(parsedSection2 = []) {
  if (!Array.isArray(parsedSection2) || parsedSection2.length === 0) return [];

  const items = parsedSection2
    .map((it) => {
      if (!it || !it.key) return null;
      const key = String(it.key || "").trim();
      const camel = toCamel(key);
      return {
        src: it,
        key,
        camel,
        label: it.label ?? "",
        label_master: it.label ?? "",
        type: it.type ?? "",
        value: parseNumberLike(it.value ?? it.rate ?? it.Cash ?? ""),
        total: parseNumberLike(it.total ?? it.rate ?? it.Cash ?? ""),
        sr_no: typeof it.sr_no === "number" ? it.sr_no : null,
        lock: it.lock ?? null,
      };
    })
    .filter(Boolean)
    .sort((a, b) => {
      const an = a.sr_no == null ? 1e9 : a.sr_no;
      const bn = b.sr_no == null ? 1e9 : b.sr_no;
      return an - bn;
    });

  const rows = items.map((it, index) => {
   // const leftName = it.label;
   // const midName = `${it.camel}Type`;
  //  const rightName = `${it.camel}Rate`;
  //  const totalName = `${it.camel}Total`;

    const options =
      typeof it.type === "string" && it.type.length
        ? it.type.split(/[/|;,]+/).map((s) => s.trim()).filter(Boolean)
        : [];

    return {
      left: {
        name: `closingCostsMeta.${index}.label`,
        label: it.label || "",
        camelKey: it.camel,
        locked: it.lock === "Y" || it.lock === "y",
        apply:it.apply || "N",
        cashvalue: it.Cash || "0.00",
      },
      mid: {
        name: `closingCostsMeta.${index}.type`,
        placeholder: it.type || "",
        options,
      },
      right: {
        name: `closingCostsMeta.${index}.value`,
        placeholder: it.value != null ? String(it.value) : "",
      },
      totalrow: {
        name: `closingCostsMeta.${index}.total`,
        placeholder: it.total != null ? String(it.total) : "",
      },
      _meta: { index, camel: it.camel, key: it.key },
    };
  });

  return rows;
}
